module.exports = __webpack_public_path__ + "img/cash.84d9adcc.svg";